import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import UpdateButton from "../../../shared/UpdateButton/UpdateButton";
import {ElectronicClockApi} from "../../../../services/ElectronicClock.api";
import NotificationFactory from "../../../../shared/Notifications";
import {DatePicker, Input, InputGroup, InputNumber, Slider, toaster, Toggle, Whisper} from "rsuite";
import {SharedApi} from "../../../../services/Shared.api";
import {extractTimezoneFromISO} from "../../ExternalDevices/components/Dimmer/utils/Dimmer.utils";
import GearIcon from "@rsuite/icons/Gear";
import {getTooltip} from "../../../../shared/Tooltip";
import {DisplayDurationsView, ElectronicClockParams, ElectronicClockSectionProps} from "../MainPage.model";

const ElectronicClockSection = ({ electronicClock, deviceId }: ElectronicClockSectionProps) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [params, setParams] = useState<ElectronicClockParams | null>(null);
    const [displayDurations, setDisplayDurations] = useState<DisplayDurationsView>({
        time: 0,
        date: 0,
        temperature: 0
    });
    const [userTimezone, setUserTimezone] = useState('');
    const [deviceTime, setDeviceTime] = useState<Date | null>(null)

    useEffect(() => {
        if (electronicClock?.id !== null && electronicClock?.id !== undefined) {
            getParams().then();
            getTime().then()
        }
    }, [electronicClock?.id]);

    const getParams = async () => {
        setLoading(true);
        try {
            const result = await ElectronicClockApi.getElectronicClockParams(electronicClock?.id);
            setParams(result);

            if (result?.displayDurations) {
                setDisplayDurations({
                    time: result.displayDurations.time || 0,
                    date: result.displayDurations.date || 0,
                    temperature: result.displayDurations.temperature || 0
                });
            }


        } catch (error) {
            toaster.push(
                NotificationFactory.error("Ошибка"),
                {placement: "topEnd"}
            );
        } finally {
            setLoading(false);
        }
    }

    const getTime = async () => {
        setLoading(true);

        try {
            const data = await SharedApi.getTime(electronicClock?.id);

            if (data.time) {
                const timezone = extractTimezoneFromISO(data.time);
                setUserTimezone(timezone);

                const date = new Date(data.time);
                setDeviceTime(date);
            }
        } catch (e) {
            console.error("Ошибка получения данных:", e);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="fieldset-wrapper">
            <div className="legend-title main-legend-title">Электронные часы {electronicClock?.model}</div>
            <section className="primary-clock">
                <div className="col-md-12 text-end">
                    <UpdateButton
                        loading={loading}
                        onRefresh={getParams}
                    />
                </div>
                <div className="row p-2">
                    <div className="col-md-4">
                        <Toggle
                            disabled={true}
                            className="me-2"
                            size={"sm"}
                            checked={params?.displayEnabled}
                            loading={loading}
                            color="blue"
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                        Вкл/ Выкл
                    </div>
                    <div className="col-md-8 d-flex align-items-center">
                        <div className="mb-2">
                            Яркость: {params?.displayBrightness}
                        </div>
                       <div>
                           <Slider
                               style={{marginLeft: 15, marginBottom: 5, width: 150}}
                               value={params?.displayBrightness}
                               readOnly={true}
                           />
                       </div>
                    </div>
                </div>
                <div className="row p-2 align-items-center">
                    <div className="col-md-1">
                        <Toggle
                            className="me-2"
                            size="sm"
                            checked={!!displayDurations.time}
                            loading={loading}
                            color="blue"
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </div>
                    <div className="col-md-11 d-flex align-items-center">
                        <InputGroup style={{width: 100}}>
                            <InputNumber
                                value={displayDurations.time}
                                readOnly={true}
                            />
                        </InputGroup>
                        <p className="info-title ms-3">Время -- / --</p>
                    </div>
                </div>
                <div className="row p-2 align-items-center">
                    <div className="col-md-1">
                        <Toggle
                            className="me-2"
                            size="sm"
                            checked={!!displayDurations.date}
                            color="blue"
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-11 d-flex align-items-center">
                        <InputGroup style={{width: 100}}>
                            <InputNumber
                                value={displayDurations.date}
                                readOnly={true}
                            />
                        </InputGroup>
                        <p className="info-title ms-3">Дата -- / --</p>
                    </div>
                </div>
                <div className="row p-2 align-items-center">
                    <div className="col-md-1">
                        <Toggle
                            className="me-2"
                            size="sm"
                            checked={!!displayDurations.temperature}
                            color="blue"
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </div>
                    <div className="col-md-11 d-flex align-items-center">
                        <InputGroup style={{width: 100}}>
                            <InputNumber
                                value={displayDurations.temperature}
                                readOnly={true}
                            />
                        </InputGroup>
                        <p className="info-title ms-3">Темп. С° : {params?.sensorTemperature}</p>
                    </div>
                    <div className="col-md-2">

                    </div>
                </div>
                <div className="row p-2">
                    <div className="col-md-7">
                        <div style={{width: '100%'}}>
                            <InputGroup style={{marginBottom: '5px', width: '100%',}}>
                                <InputGroup.Addon>Время</InputGroup.Addon>
                                <DatePicker
                                    style={{width: '100%'}}
                                    value={deviceTime ?? null}
                                    format="dd.MM.yyyy HH:mm"
                                    cleanable={false}
                                    readOnly={true}
                                />
                            </InputGroup>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="col-md-3">
                            <InputGroup style={{width: 130}} className="mb-1">
                                <InputGroup.Addon>Час. пояс</InputGroup.Addon>
                                <Input
                                    readOnly={true}
                                    value={userTimezone}
                                    style={{textAlign: 'center'}}
                                />
                            </InputGroup>
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-12 text-end">
                        <a
                            className="settings-link"
                            href="#"
                            onClick={(e) => {
                                navigate(`/devices/${deviceId}?tab=devices&externalId=${electronicClock?.id}`);
                                e.preventDefault();
                            }}
                        >
                          <Whisper
                            placement="topStart"
                            controlId="control-id-hover"
                            trigger="hover"
                            speaker={getTooltip('Перейти в настройки')}>
                            <GearIcon className="gear-icon"></GearIcon>
                          </Whisper>
                        </a>
                    </div>
                </div>
            </section>
        </div>
    )
};

export default ElectronicClockSection;
